import { Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { StyledLoginFormContainer } from "../styled-login-form-container";
import { PacknetLogo } from "../packnet-logo";

export const MissingFeatureFlag = () => {
	return (
		<StyledLoginFormContainer maxWidth="sm" data-testid="missing-feature-flag">
			<Grid container direction="column" gap={6}>
				<PacknetLogo />

				<Grid container direction="column" gap={2}>
					<Typography fontWeight="bold">
						<FormattedMessage id="missing-feature-flag.header" defaultMessage="Feature not available" />
					</Typography>
					<Typography>
						<FormattedMessage
							id="missing-feature-flag.subheader"
							defaultMessage="We're sorry, but this feature is not available. Please contact Packsize Support."
						/>
					</Typography>
				</Grid>
			</Grid>
		</StyledLoginFormContainer>
	);
};
